import {
  afterNextRender,
  DestroyRef,
  Directive,
  effect,
  EventEmitter,
  inject,
  input,
  model,
  OnDestroy,
  Signal,
  signal,
  TemplateRef,
  Type,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[uicontentcomponent]',
  standalone: true,
})
export class UiContentComponentDirective {
  private readonly destroyRef = inject(DestroyRef);

  uicontentcomponent = input<Type<any> | null>(null);
  uicontentinput = input<any | undefined>(undefined);
  uicontenttemplate = input<TemplateRef<any> | null>(null);
  uicontentcontext = model<any | undefined>(undefined);
  uicontentcontextmore = model<any | undefined>(undefined);
  /* uicontentoutput = input<
    Array<{ name: string; fn: any; args?: any }> | undefined
  >(undefined);
  uicontainerRef: Signal<ViewContainerRef | undefined> = signal<
    ViewContainerRef | undefined
  >(undefined); */

  constructor() {
    /* afterNextRender(() => {
      if (this.uicontentcomponent()) {
        this.loadComponent();
      }
    }); */
  }

  //TODO: With Angular v20 this will change to bindings, until then we use ngComponentOutlet on the host component
  public loadComponent() {
    /* let component = this.uicontainerRef()?.createComponent(
      this.uicontentcomponent()!,
    );
    if (!component) {
      return;
    }

    this.uicontentinput()?.forEach((uicontentinput) => {
      component.setInput(uicontentinput.name, uicontentinput.value);
    });

    this.uicontentoutput()?.forEach((uicontentoutput) => {
      let output = component.instance[
        uicontentoutput.name
      ] as EventEmitter<any>;
      output.subscribe((event: any) => {
        uicontentoutput.fn();
        console.log('Event:', output.arguments, event);
      });
    }); */
  }
}
